import React, { useState, useEffect } from 'react';
import { Eye } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const LiveVisitorCount = ({ variant = 'inline' }) => {
  const { language } = useLanguage();
  const [count, setCount] = useState(0);

  useEffect(() => {
    const base = Math.floor(Math.random() * 6) + 8;
    setCount(base);

    const interval = setInterval(() => {
      setCount(prev => {
        const change = Math.random() > 0.5 ? 1 : -1;
        const next = prev + change;
        if (next < 5) return prev + 1;
        if (next > 22) return prev - 1;
        return next;
      });
    }, 12000);

    return () => clearInterval(interval);
  }, []);

  if (count === 0) return null;

  if (variant === 'badge') {
    return (
      <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2" data-testid="live-visitor-badge">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
        </span>
        <Eye className="w-3.5 h-3.5 text-green-300" />
        <span className="text-sm text-white font-medium">
          <span className="font-bold">{count}</span>{' '}
          {language === 'en' ? 'people viewing this page' : 'personnes consultent cette page'}
        </span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 text-xs md:text-sm" data-testid="live-visitor-count">
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-500 opacity-75"></span>
        <span className="relative inline-flex rounded-full h-2 w-2 bg-green-600"></span>
      </span>
      <Eye className="w-3 h-3 md:w-3.5 md:h-3.5 text-gray-500" />
      <span className="text-gray-600">
        <span className="font-bold text-gray-800">{count}</span>{' '}
        {language === 'en' ? 'people viewing this page now' : 'personnes consultent cette page'}
      </span>
    </div>
  );
};

export default LiveVisitorCount;
